import React from 'react';
import {Card} from '@mui/material';
import {gallerySurface} from '../theme/publicTheme';

export default function CardArta({sx, children, ...props}) {
    return <Card elevation={0} sx={{bgcolor: gallerySurface, border: 1, borderColor: 'divider', ...sx}} {...props}>{children}</Card>;
}
